import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Alert, Col, Row, Table } from 'react-bootstrap';
import ConfirmModal from '../components/ConfirmModal';
import CustomList from '../components/CustomList';
import ApiUtil from '../utils/api';

const PeriodicBillsDueList = observer(
  class List extends CustomList {
    constructor(props) {
      super(props);

      this.state = {
        data: [],
        errors: '',
      };
    }

    async componentDidMount() {
      await this.loadData(this.props);
    }

    /**
     * Function to load the due periodic bills
     */
    loadData = async params => {
      const query = `get_properties_ready_for_billing?${ApiUtil._buildQueryParams(params)}`;
      const { num_pages, results, count } = await ApiUtil.billingAPI({ query });

      this.setState({ num_pages, data: results, total_count: count });
    };

    /**
     * Cause the bill approval report for a property to be generated
     */
    onGenerate = async (building_id, building_name) => {
      ApiUtil.billingAPI({
        requestType: 'POST',
        query: `create_bar_for_billing_cycle`,
        id: building_id,
      })
        .then(response => {
          let bill_approval_report_id = response['bill_approval_report_id'];
          this.props.history.push(`/billing-approval-reports/${bill_approval_report_id}`);
        })
        .catch(error => this.handleErrors(error, building_name));
    };

    /**
     * Handles the tariff errors and sets it in the state.
     *
     * @param {Object} errors - errors data
     */
    handleErrors(errors) {
      if (errors && errors.validationErrors) {
        const errorsArray = [];

        // Non field errors go to the state
        if (errors.validationErrors.non_field_errors) {
          errorsArray.push(...errors.validationErrors.non_field_errors);
        }

        // Saving errors
        this.setState({ errors: errorsArray });
      } else {
        // We only care about validation errors
        throw errors;
      }
    }

    /**
     * Renders the due bills line items into HTML
     */
    renderItems() {
      const items = this.state.data.map(item => (
        <tr key={item.id}>
          <td>
            {item.address_1}, {item.postcode}
          </td>
          <td>
            {item.previous_bill_start} - {item.previous_bill_end}
          </td>
          <td>
            <ConfirmModal
              textButton="Generate Bills"
              textTitle="Confirm Bill Generation"
              textContent={`Are you sure you want to generate bills for ${item.address_1}?`}
              textCancelButton="Cancel"
              data={{ id: this.state.building_id }}
              functionConfirm={() => this.onGenerate(item.id, item.address_1)}
            />
          </td>
        </tr>
      ));
      return items.length ? (
        items
      ) : (
        <tr>
          <td colSpan="6">We couldn't find any properties.</td>
        </tr>
      );
    }

    /**
     * Renders the list of buildings with bills which are due to be generated.
     */
    renderList() {
      return (
        <Row>
          <Col xs={12} className="mb-20 actionableContentColor">
            <h2 className="mb-20">Periodic Bills Due</h2>
            {this.state.errors.length > 0 && <Alert bsStyle="danger">{this.state.errors}</Alert>}
            <Table responsive hover striped>
              <thead>
                <tr>
                  <th>Building</th>
                  <th>Due Bill Period</th>
                  <th />
                </tr>
              </thead>
              <tbody>{this.renderItems()}</tbody>
            </Table>
          </Col>
        </Row>
      );
    }

    render() {
      return this.renderList();
    }
  },
);

export default withRouter(PeriodicBillsDueList);



// WEBPACK FOOTER //
// ./src/containers/PeriodicBillsDueList.js